export default "__VITE_ASSET__CC234L3G__"